module.exports = __webpack_public_path__ + "img/soundfield_4.6e97968a.jpg";